import { render, staticRenderFns } from "./portOfDestinationServices.vue?vue&type=template&id=aeab37c0&"
import script from "./portOfDestinationServices.vue?vue&type=script&lang=js&"
export * from "./portOfDestinationServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aeab37c0')) {
      api.createRecord('aeab37c0', component.options)
    } else {
      api.reload('aeab37c0', component.options)
    }
    module.hot.accept("./portOfDestinationServices.vue?vue&type=template&id=aeab37c0&", function () {
      api.rerender('aeab37c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/basic/portOfDestinationServices.vue"
export default component.exports